/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown>, value: NonNullable<unknown> }} Chain_Page_Compare_Consensus_SameInputs */



/**
* | output |
* | --- |
* | "{leftChain} and {rightChain} are both {value}" |
*
* @param {Chain_Page_Compare_Consensus_SameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_consensus_same = /** @type {((inputs: Chain_Page_Compare_Consensus_SameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Consensus_SameInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} and ${i?.rightChain} are both ${i?.value}`)
});